<template>
  <app-card
    interactive
    :to="{ name: ROUTE_NAMES.MENU, hash: categoryHash }"
    :class="['category-card', 'theme-group-3', { 'category-card--no-image': isNoImage }]"
  >
    <div class="category-card__image-container m-8">
      <img
        v-if="!isNoImage"
        v-image-fall-back="imgFallback"
        :src="getImage"
        alt=""
        role="presentation"
        class="category-card__image"
      />
      <div class="category-card__darken prop-transition"></div>
      <div class="category-card__title">{{ category.displayName }}</div>
    </div>
    <div
      v-if="showDescription"
      :class="[
        'category-card__description',
        'iw-item-description',
        { 'category-card__description--empty': showEmptyDescription }
      ]"
    >
      {{ getCategoryDescription }}
    </div>
  </app-card>
</template>

<script>
import IMG_FALLBACK from "@/assets/images/vendor_missing.svg";
import { removeSpecialCharaters, ROUTE_NAMES } from "../../../../utils";
import AppCard from "@/components/base/app-card/AppCard";

export default {
  name: "CategoryCard",
  components: { AppCard },
  props: {
    category: Object,
    showImage: Boolean,
    showDescription: Boolean
  },
  data() {
    return {
      imgFallback: IMG_FALLBACK,
      ROUTE_NAMES
    };
  },
  computed: {
    categoryHash() {
      return `#${removeSpecialCharaters(this.category.displayName).replace(/\s+/g, "_").toLowerCase()}`;
    },
    getCategoryDescription() {
      return this.category.description;
    },
    getImage() {
      return this.category.image.image || IMG_FALLBACK;
    },
    isNoImage() {
      return !this.showImage || !this.getImage;
    },
    showEmptyDescription() {
      return this.showDescription && !this.getCategoryDescription;
    }
  }
};
</script>

<style lang="scss" scoped>
.category-card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  padding: 0;

  &__darken {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }

  &__image-container {
    position: relative;
    width: calc(100% - 16px);
    height: 140px;
  }

  &__image {
    width: 100%;
    height: 140px;
    object-fit: cover;
  }

  &__description {
    overflow: hidden;
    // add 25% to adjust the balance
    width: calc(100% - 32px);
    height: 44px;
    margin: 8px 16px 16px;
    border-bottom: none;
  }

  &__description--empty {
    display: none;
  }

  &__title {
    display: flex;
    justify-content: center;
    align-items: center;
    width: -webkit-fill-available;
    height: inherit;
    color: $group-3-color-1;
    position: absolute;
    top: 0;
    text-align: center;
    word-wrap: break-word;
    width: 100%;
    font-size: 20px;
    margin: 0;
    font-style: normal;
    line-height: 1.2;
    font-weight: bold;
  }

  &--no-image {
    .category-card__darken {
      background-color: rgba(0, 0, 0, 0);
    }

    .category-card__title {
      color: $group-3-color-2;
    }
  }

  @include respond-to-mobile {
    flex-direction: row;

    &__image {
      height: 100px;
    }

    &__image-container {
      height: 100px;
    }

    &__description {
      overflow: scroll;
      overflow-x: hidden;
      // add 25% to adjust the balance
      width: 125%;
      height: 94px;
    }

    &__description--empty {
      display: initial;
    }

    &--no-image {
      height: 116px;
    }
  }
}
</style>
